export default "__VITE_ASSET__f1241a7c__"